/* VER-PDP-2 v2, 01.09.2026 (Wolfram): eigener Bild-Zoom ohne Theme-Lightbox.
   Desktop (hover+fine pointer): Hover-Zoom 2.2x, Ursprung folgt der Maus,
   beim ersten Hover wird die 1800px-Quelle nachgeladen.
   Mobil, bewusst simpel (Wolfram): EIN Tipp aufs Bild oeffnet das Vollbild,
   der NAECHSTE einfache Tipp schliesst es wieder. Fuer Detailarbeit zusaetzlich:
   Doppeltipp (1x/2.5x), Pinch und Ein-Finger-Verschieben im gezoomten Zustand. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    var imgs = document.querySelectorAll('.product__main-photos .product-image-main img[data-photoswipe-src]');
    if (!imgs.length) { return; }
    var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isDesktop) {
      imgs.forEach(function (img) {
        var wrap = img.closest('.image-wrap');
        if (!wrap) { return; }
        wrap.classList.add('ver-zoom-wrap');
        var hiRes = false;
        wrap.addEventListener('mouseenter', function () {
          if (!hiRes) {
            var big = img.getAttribute('data-photoswipe-src');
            if (big) { img.removeAttribute('srcset'); img.removeAttribute('data-sizes'); img.src = big; }
            hiRes = true;
          }
        });
        wrap.addEventListener('mousemove', function (e) {
          var r = wrap.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(2.2)';
        });
        wrap.addEventListener('mouseleave', function () { img.style.transform = ''; });
      });
    } else {
      imgs.forEach(function (img) {
        img.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          openOverlay(img.getAttribute('data-photoswipe-src') || img.currentSrc || img.src);
        });
      });
    }
    function openOverlay(src) {
      var ov = document.createElement('div');
      ov.className = 'ver-zoom-overlay';
      ov.innerHTML = '<button type="button" class="ver-zoom-close" aria-label="Schliessen">×</button>' +
        '<div class="ver-zoom-stage"><img alt="" src="' + src + '"></div>';
      document.body.appendChild(ov);
      document.documentElement.classList.add('ver-zoom-lock');
      var stage = ov.querySelector('.ver-zoom-stage');
      var pic = ov.querySelector('img');
      var scale = 1, tx = 0, ty = 0, start = null, pinch = null, lastTap = 0;
      var closeTimer = null, moved = false;
      function apply() { pic.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
      function close() { ov.remove(); document.documentElement.classList.remove('ver-zoom-lock'); }
      function dist(e) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      ov.querySelector('.ver-zoom-close').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target === stage) { close(); } });
      stage.addEventListener('touchstart', function (e) {
        moved = false;
        if (e.touches.length === 2) { pinch = { d: dist(e), s: scale }; if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
        else if (e.touches.length === 1) {
          var now = Date.now();
          if (now - lastTap < 300) {
            if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
            scale = scale > 1 ? 1 : 2.5;
            if (scale === 1) { tx = 0; ty = 0; }
            apply();
            lastTap = 0;
            start = { x: e.touches[0].clientX - tx, y: e.touches[0].clientY - ty };
            return;
          }
          lastTap = now;
          start = { x: e.touches[0].clientX - tx, y: e.touches[0].clientY - ty };
        }
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && pinch) {
          scale = Math.min(5, Math.max(1, pinch.s * dist(e) / pinch.d));
          apply();
          e.preventDefault();
        } else if (e.touches.length === 1 && start && scale > 1) {
          moved = true;
          tx = e.touches[0].clientX - start.x;
          ty = e.touches[0].clientY - start.y;
          apply();
          e.preventDefault();
        } else if (e.touches.length === 1) {
          moved = true;
        }
      }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) { pinch = null; }
        if (scale <= 1) { tx = 0; ty = 0; apply(); }
        if (e.touches.length === 0 && !moved && scale <= 1 && lastTap > 0) {
          if (closeTimer) { clearTimeout(closeTimer); }
          closeTimer = setTimeout(close, 320);
        }
      });
    }
  });
})();

/* VER-PDP-10 v4, 01.09.2026 (Wolfram): Bildhoehen-Deckel fuer die sticky
   Galerie am Desktop. Der padding-bottom-Platzhalter je .image-wrap wird
   rennen-frei auf min(Originalverhaeltnis, 100vh-140px) gedeckelt — die
   Hoehe ist damit VOR jedem Bildload definiert (v1 scheiterte am Timing:
   Flickity mass vor dem Load und kollabierte die Galerie auf 48px).
   v3: Deckel exakt 100vh-140px = Sticky-Offset — die Bild-Unterkante
   schliesst im Klebe-Zustand buendig mit dem unteren Fensterrand ab.
   v4: Zusatz-Trigger (load + 400ms + 1500ms), weil der reine
   DOMContentLoaded-Lauf die Galerie verpassen kann, wenn deren Breite erst
   spaeter steht (live beobachtet: Deckel lief nicht, Galerie blieb 813px).
   Die Thumbnail-Leiste folgt der Galeriehoehe von selbst (Theme-CSS).
   Konvergenz-Guard verhindert resize-Schleifen. Mobil: Originalwert.
   Rueckbau: diesen Abschnitt + CSS-Block VER-PDP-10 entfernen. */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  var applying = false;
  function capWraps() {
    if (applying) { return; }
    var wraps = document.querySelectorAll('.product-single__sticky .product-image-main .image-wrap');
    if (!wraps.length) { return; }
    var changed = false;
    wraps.forEach(function (w) {
      if (!w.dataset.verOrigPb) {
        var pb = parseFloat(w.style.paddingBottom);
        if (!pb) { return; }
        w.dataset.verOrigPb = String(pb);
      }
      var orig = parseFloat(w.dataset.verOrigPb);
      var target = orig;
      if (mq.matches) {
        var wWidth = w.clientWidth || w.getBoundingClientRect().width;
        if (!wWidth) { return; }
        var capPct = ((window.innerHeight - 140) / wWidth) * 100;
        target = Math.min(orig, capPct);
      }
      var current = parseFloat(w.style.paddingBottom);
      if (isNaN(current) || Math.abs(current - target) > 0.5) {
        w.style.paddingBottom = target + '%';
        changed = true;
      }
    });
    if (changed) {
      applying = true;
      window.dispatchEvent(new Event('resize'));
      setTimeout(function () { applying = false; }, 80);
    }
  }
  if (document.readyState !== 'loading') { capWraps(); }
  else { document.addEventListener('DOMContentLoaded', capWraps); }
  window.addEventListener('load', capWraps);
  setTimeout(capWraps, 400);
  setTimeout(capWraps, 1500);
  window.addEventListener('resize', function () { setTimeout(capWraps, 60); });
})();
